import { useEffect, useRef } from "react";
import { useLocation } from "react-router-dom";
import { useCookieConsent } from "@/components/CookieConsentContext";

const pixelId = "1109736311821516";

function initializeMetaPixel() {
  if (window.fbq) return;

  window.fbq = function () {
    if (window.fbq.callMethod) {
      window.fbq.callMethod.apply(window.fbq, arguments);
    } else {
      window.fbq.queue.push(arguments);
    }
  };
  window.fbq.push = window.fbq;
  window.fbq.loaded = true;
  window.fbq.version = "2.0";
  window.fbq.queue = [];
  window._fbq = window.fbq;

  const script = document.createElement("script");
  script.async = true;
  script.src = "https://connect.facebook.net/en_US/fbevents.js";
  document.head.appendChild(script);
}

function removeMetaCookies() {
  const host = window.location.hostname;
  ["_fbp", "_fbc"].forEach((name) => {
    document.cookie = `${name}=; Max-Age=0; path=/; SameSite=Lax`;
    document.cookie = `${name}=; Max-Age=0; path=/; domain=${host}; SameSite=Lax`;
    if (host.includes(".")) document.cookie = `${name}=; Max-Age=0; path=/; domain=.${host}; SameSite=Lax`;
  });
}

function MetaPixel() {
  const location = useLocation();
  const lastPageView = useRef(null);
  const { consent } = useCookieConsent();

  useEffect(() => {
    if (!consent.marketing) {
      if (window.fbq) window.fbq("consent", "revoke");
      removeMetaCookies();
      lastPageView.current = null;
      return;
    }

    initializeMetaPixel();
    if (window.__metaPixelId !== pixelId) {
      window.fbq("set", "autoConfig", false, pixelId);
      window.fbq("init", pixelId);
      window.__metaPixelId = pixelId;
    }
    window.fbq("consent", "grant");
  }, [consent.marketing]);

  useEffect(() => {
    if (!consent.marketing || !window.fbq || location.search || location.hash || location.pathname.startsWith("/pack/planificador/")) return;

    const currentPage = location.pathname;
    if (lastPageView.current === currentPage) return;

    window.fbq("track", "PageView");
    lastPageView.current = currentPage;
  }, [consent.marketing, location.pathname, location.search, location.hash]);

  return null;
}

export default MetaPixel;